
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
    TableContainer, styled,
    Table,
    TableBody,
    TableCell,

    TableHead,
    TableRow,
} from "@mui/material";
import { numberFormatter } from "../../../utils/formatter";


type MetaData = {
    url: string;
    headingValue: string;
    Project: {
        label: string,
        value: string
    };
    NonProject: {
        label: string,
        value: string
    }
}

type Heading = "pricing" | "sku"

const getData: (heading: Heading, selectedCustomerId: string, data: any) => MetaData | undefined = (heading, selectedCustomerId, data) => {
    const projectOpp = data?.Project?.enabled ? `$${numberFormatter(data?.Project?.opportunity, 1)}` : `-`;
    const nonProjectOpp = data?.NonProject?.enabled ? `$${numberFormatter(data?.NonProject?.opportunity, 1)}` : `-`;
    switch (heading) {
        case "pricing":
            return {
                url: "/pricing?customer=" + selectedCustomerId,
                headingValue: "Pricing",
                NonProject: {
                    label: data?.NonProject?.enabled ? `Increase Non-project prices for ${data?.NonProject?.itemsCount} items that are being sold below the target price ` : `-`,
                    value: nonProjectOpp,
                },
                Project: {
                    label: data?.Project?.enabled ? `Increase Project prices for ${data?.Project?.itemsCount} items that are being sold below the target price` : `-`,
                    value: projectOpp,
                }
            };
        case "sku":
            return {
                url: "/sku?customer=" + selectedCustomerId,
                headingValue: "SKU Substitution",
                NonProject: {
                    label: data?.NonProject?.enabled ? `Substitute ${data?.NonProject?.itemsCount} Non-project SKU's to optimize margin` : `-`,
                    value: nonProjectOpp
                },
                Project: {
                    label: data?.Project?.enabled ? `Substitute ${data?.Project?.itemsCount} Project SKU's to optimize margin` : `-`,
                    value: projectOpp,
                }
            };
        default:
            return;
    }
};

const ServicesTable = (props: {
    data: any;
    headerValue: Heading;
    selectedCustomerId: any;
    selectedScatterData: any
    isFilterExpanded: boolean
}) => {
    const { data, headerValue, selectedCustomerId, isFilterExpanded } = props;
    const navigate = useNavigate();
    const isDataPresent = data?.NonProject?.enabled || data?.Project?.enabled
    const StyledTableCellData = styled(TableCell)({
        lineHeight: 1.4,
        fontSize: "1.4vh",
        fontFamily:
            'BlinkMacSystemFont,-apple-system,"Segoe UI","Roboto","Oxygen","Ubuntu","Cantarell","Fira Sans","Droid Sans","Helvetica Neue","Helvetica","Arial",sans-serif',
        background: "none",
        padding: "0.5vw",
    });

    const metaData = getData(headerValue, selectedCustomerId, data);

    const headerStyle = {
        color: "black",
        border: "1px solid #bebebe",
        borderBottom: "3px solid #bebebe",
        backgroundColor: "white",
        fontSize: "0.7vw",

    };
    const columnStyle = {
        color: "black",
        borderRight: "0.1px solid #bebebe",
        borderBottom: "0.1px solid #bebebe",
        innerHeight: "36px",
    };

    return (
        <TableContainer
            className={`${isDataPresent && "table-container"}`}
            sx={{
                display: "flex",
                justifyContent: "center",
                // opacity: isDataPresent ? 1 : 0.6,
            }}
        >
            <Table
                sx={{
                    width: "100 %",
                    fontStyle: isDataPresent ? "italic" : "none",
                    background: "white"
                }}
            >
                <TableHead>
                    <TableRow>
                        <StyledTableCellData
                            className="alignCenter !p-[0.6vh] !font-bold"

                            sx={headerStyle}
                        >
                            {metaData?.headingValue}
                        </StyledTableCellData>
                        <StyledTableCellData
                            className="alignCenter !p-[0.6vh] !font-bold"
                            sx={headerStyle}
                        >
                            Oppty
                        </StyledTableCellData>
                    </TableRow>
                </TableHead>
                <TableBody >
                    <TableRow className={`even ${isFilterExpanded ? "h-[5vh]" : "h-[6vh]"}`} sx={{
                        cursor: data?.NonProject?.enabled === true ? "pointer" : "",
                    }} onClick={() => {
                        data?.NonProject?.enabled === true && metaData?.url ? navigate(metaData.url) : {}
                    }}>
                        <StyledTableCellData
                            className="!p-[0.6vh]"
                            width="80%"
                            sx={{
                                ...columnStyle,
                                textAlign: data?.NonProject?.enabled ? "left" : "center"
                            }}

                        >
                            {metaData?.NonProject.label || "-"}
                        </StyledTableCellData>
                        <StyledTableCellData className="!p-[0.6vh]" sx={{
                            textAlign: "center", ...columnStyle,
                        }} width="20%">
                            {metaData?.NonProject.value || "-"}
                        </StyledTableCellData>
                    </TableRow>
                    <TableRow className={`${isFilterExpanded ? "h-[5vh]" : "h-[6vh]"}`} sx={{
                        cursor: data?.Project?.enabled === true ? "pointer" : "",
                    }} onClick={() => {
                        data?.Project?.enabled === true && metaData?.url ? navigate(metaData.url) : {}
                    }}>
                        <StyledTableCellData
                            className="!p-[0.6vh]"
                            width="80%"
                            sx={{
                                textAlign: data?.Project?.enabled ? "left" : "center", ...columnStyle,
                            }}
                        >
                            {metaData?.Project.label || "-"}
                        </StyledTableCellData>
                        <StyledTableCellData
                            className="!p-[0.6vh]"
                            sx={{
                                textAlign: "center", ...columnStyle,
                            }} width="20%">
                            {metaData?.Project.value || "-"}
                        </StyledTableCellData>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer >
    );
};

export default ServicesTable;
